import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export type IBadgesData = {
	text: string;
	bgClass?: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'dark' | 'gray' | 'light';
};

export type IBadgesProps = {
	dataSource: IBadgesData[];
	sizeClass?: 'xl' | 'lg' | 'md' | 'sm' | 'xs';
	bgClass?: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'dark' | 'gray' | 'light';
	preset?: 'dim' | 'outline' | 'dimoutline';
	rounded?: boolean;
    className?: string;
};

const themeToVariant = (theme?: string): 'default' | 'secondary' | 'destructive' | 'outline' => {
	switch (theme) {
		case 'primary': return 'default';
		case 'danger': return 'destructive';
		case 'success':
		case 'warning':
		case 'info':
		case 'secondary': return 'secondary';
		case 'dark':
		case 'gray':
		case 'light': return 'outline';
		default: return 'secondary';
	}
};

const bgObject = ['primary' , 'secondary' , 'success' , 'info' , 'warning' , 'dark' , 'gray' , 'light'];

export const Badges = (props: IBadgesProps) => {
	const { sizeClass, dataSource, bgClass, preset, rounded, className } = props;
    
	const getRandomObject = () => {
        const randomObject = bgObject[Math.floor(Math.random() * bgObject.length)];
        return randomObject;
    };

	const sizeMap = {
		xs: 'text-xs',
		sm: 'text-sm',
		md: 'text-base',
		lg: 'text-lg',
		xl: 'text-xl',
	};

	return (
		<div className={cn("flex flex-wrap gap-2", className)}>
			{dataSource &&
				dataSource.map((item, idx) => {
					const ___bgClass = item.bgClass || bgClass || getRandomObject();
					const variant = themeToVariant(___bgClass);
					
					return (
						<Badge
							key={idx}
							variant={preset === 'outline' ? 'outline' : variant}
							className={cn(
								sizeMap[sizeClass as keyof typeof sizeMap] || sizeMap.sm,
								rounded && "rounded-full"
							)}
						>
							{item.text}
						</Badge>
					);
				})}
		</div>
	);
};
